// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seed-section {
  font-size: 16px;
}
.seed-section .seed-header {
  display: flex;
  justify-content: space-between;
}
.seed-section .seed-header .seed-text {
  font-family: "Inter", sans-serif;
  font-weight: bold;
  font-size: 14px;
}
.seed-section .seed-header .seed-points {
  font-size: 14px;
  font-weight: 400;
}
.seed-section .seed-content {
  display: flex;
  margin-top: 1rem;
  position: relative;
}
.seed-section .seed-content .seed-wrapper {
  position: relative;
}
.seed-section .seed-content .seed-wrapper:last-child .seed {
  background-color: #f5f5f5;
  border: 1px solid #000000;
}
.seed-section .seed-content .seed-wrapper:not(:last-child)::after {
  height: var(--coffe-seed-line-height);
  background-color: #cccccc;
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  right: -0.5rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.seed-section .seed-content .seed-wrapper.line-active:not(:last-child)::after {
  background-color: #FFC61D;
}
.seed-section .seed-content .seed-wrapper.seed-active .seed {
  background-color: #FFC61D;
}
.seed-section .seed-content .seed {
  width: var(--coffe-seed-size);
  height: var(--coffe-seed-size);
  background-color: #cccccc;
  border-radius: 50%;
  position: relative;
  z-index: 2;
}
.seed-section .seed-content .seed .seed-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.seed-section .use-section {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
.seed-section .use-section .use-text {
  font-family: "Montserrat", sans-serif;
  font-weight: normal;
  font-size: clamp(0.65rem, 2vw, 1rem);
  max-width: 70%;
  align-self: center;
}
.seed-section .use-section .use-text.virtual {
  max-width: 100%;
  text-align: center;
}
.seed-section .use-section ion-button {
  --background: #FFC61D;
  opacity: 1;
  --color: black;
  --border-radius: 1rem;
  font-weight: bold;
  letter-spacing: 0;
}
.seed-section .use-section ion-button.button-disabled {
  opacity: 0.7;
}

@media (min-width: 768px) {
  .seed-section .seed-content .seed-wrapper::after {
    height: 8px !important;
  }
  .seed-section .seed-content.seed {
    width: 3rem;
    height: 3rem;
  }
}
.details-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 0 10px;
  background-color: #F5F5F5;
}
.details-section .details {
  display: flex;
  justify-content: space-between;
  flex: 1;
  text-align: center;
  font-size: 14px;
}
.details-section .details div {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-weight: 600;
  position: relative;
}
.details-section .details div:nth-child(2)::after {
  content: "";
  width: 1px;
  height: 40px;
  background-color: #ddd;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.details-section .label {
  color: #777;
  font-size: 13px;
  font-weight: 400;
}
.details-section .value {
  font-weight: bold;
  font-size: 18px;
  color: black;
}

.use-button {
  display: flex;
  justify-content: flex-end;
}

ion-button {
  --background: #ffc61d;
  --color: black;
  --border-radius: 1rem;
  font-weight: bold;
  padding: 8px 16px;
  font-size: 14px;
  height: 35px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/coffee-seed/coffee-seed.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;AACJ;AACI;EACE,gCAAA;EACA,iBAAA;EACA,eAAA;AACN;AAEI;EACE,eAAA;EACA,gBAAA;AAAN;AAIE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAII;EACE,kBAAA;AAFN;AAKQ;EACE,yBAAA;EACA,yBAAA;AAHV;AAQQ;EACE,qCAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AANV;AAYU;EACE,yBAAA;AAVZ;AAeM;EACE,yBAAA;AAbR;AAiBI;EACE,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAfN;AAiBM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAfR;AAoBE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAlBJ;AAoBI;EACE,qCAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;AAlBN;AAoBM;EACE,eAAA;EACA,kBAAA;AAlBR;AAsBI;EACE,qBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;AApBN;AAsBM;EACE,YAAA;AApBR;;AA2BA;EAGI;IACE,sBAAA;EA1BJ;EA6BE;IACE,WAAA;IACA,YAAA;EA3BJ;AACF;AAgCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA9BF;AAgCE;EACE,aAAA;EACA,8BAAA;EACA,OAAA;EACA,kBAAA;EACA,eAAA;AA9BJ;AAiCE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AAhCJ;AAmCE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAjCJ;AAoCE;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AAlCJ;;AAsCA;EACE,aAAA;EACA,yBAAA;AAnCF;;AAsCA;EACE,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AAnCF","sourcesContent":[".seed-section {\n  font-size: 16px;\n\n  .seed-header {\n    display: flex;\n    justify-content: space-between;\n\n    .seed-text {\n      font-family: \"Inter\", sans-serif;\n      font-weight: bold;\n      font-size: 14px;\n    }\n\n    .seed-points {\n      font-size: 14px;\n      font-weight: 400;\n    }\n  }\n\n  .seed-content {\n    display: flex;\n    margin-top: 1rem;\n    position: relative;\n\n    .seed-wrapper {\n      position: relative;\n\n      &:last-child {\n        .seed {\n          background-color: #f5f5f5;\n          border: 1px solid #000000;\n        }\n      }\n\n      &:not(:last-child) {\n        &::after {\n          height: var(--coffe-seed-line-height);\n          background-color: #cccccc;\n          content: \"\";\n          position: absolute;\n          display: block;\n          width: 100%;\n          right: -0.5rem;\n          top: 50%;\n          transform: translateY(-50%);\n          z-index: 1;\n        }\n      }\n\n      &.line-active {\n        &:not(:last-child) {\n          &::after {\n            background-color: #FFC61D;\n          }\n        }\n      }\n\n      &.seed-active .seed {\n        background-color: #FFC61D;\n      }\n    }\n\n    .seed {\n      width: var(--coffe-seed-size);\n      height: var(--coffe-seed-size);\n      background-color: #cccccc;\n      border-radius: 50%;\n      position: relative;\n      z-index: 2;\n\n      .seed-img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n    }\n  }\n\n  .use-section {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1rem;\n\n    .use-text {\n      font-family: \"Montserrat\", sans-serif;\n      font-weight: normal;\n      font-size: clamp(0.65rem, 2vw, 1rem);\n      max-width: 70%;\n      align-self: center;\n\n      &.virtual {\n        max-width: 100%;\n        text-align: center;\n      }\n    }\n\n    ion-button {\n      --background: #FFC61D;\n      opacity: 1;\n      --color: black;\n      --border-radius: 1rem;\n      font-weight: bold;\n      letter-spacing: 0;\n\n      &.button-disabled {\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n\n@media (min-width: 768px) {\n  .seed-section .seed-content {\n\n    .seed-wrapper::after {\n      height: 8px !important;\n    }\n\n    &.seed {\n      width: 3rem;\n      height: 3rem;\n    }\n  }\n}\n\n\n.details-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding: 0 10px;\n  background-color: #F5F5F5;\n\n  .details {\n    display: flex;\n    justify-content: space-between;\n    flex: 1;\n    text-align: center;\n    font-size: 14px;\n  }\n\n  .details div {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    font-weight: 600;\n    position: relative;\n  }\n\n  .details div:nth-child(2)::after {  \n    content: \"\";\n    width: 1px;\n    height: 40px;\n    background-color: #ddd;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .label {\n    color: #777;\n    font-size: 13px;\n    font-weight: 400;\n  }\n\n  .value {\n    font-weight: bold;\n    font-size: 18px;\n    color: black;\n  }\n}\n\n.use-button {\n  display: flex;\n  justify-content: flex-end;\n}\n\nion-button {\n  --background: #ffc61d;\n  --color: black;\n  --border-radius: 1rem;\n  font-weight: bold;\n  padding: 8px 16px;\n  font-size: 14px;\n  height: 35px;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
